/*
 * Podio CheckList
 * Version 1.0
 * Written by: Daniel Pouzemski (Podio)
 *
 * Using underscore.js
 */

define('lib/jquery/jquery.podioCheckList',['require','underscore','jquery','bowser','jst!podiochecklist/_item','lunr','lib/Podio.Utils.Text'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var browser = require('bowser');
  var jstItem = require('jst!podiochecklist/_item');
  var lunr = require('lunr');
  var textUtils = require('lib/Podio.Utils.Text');

  var defaultSettings = {
    data: [],
    idKey: 'mail',
    columns : 4,
    preselectAll: false,
    inviteLimit: null,
    renderLimit: null,
    elmResultContainer: null,
    firstElementTabIndex: null,
    searchEnabled: false,
    searchFunc: null,
    searchInEmail: true,
    searchInstantSearchCallback: false,
    loadMoreFunc: null,
    loadMoreScrollThreshold: 70,
    customCheckbox : {
      checked: null,
      open: null
    },
    classes: {
      resultContainer: '.resultContainer',
      selectAll: '#select-all-checkbox',
      nonCheckable: 'non-checkable'
    },
    templates: {
      item: function(options) {
        return jstItem(options);
      },
      list:  _.template('<ul class="podio-check-list"><%-content%></ul>'),
      empty: null,
      emptyInitial: null
    },
    callbacks: {
      onCheck: function() {},
      onNonCheckableClick: function() {},
      onUncheck: function() {},
      onSelectAll: function() {},
      onUnselectAll: function() {}
    }
  };

  $.podioChecklist = function (input) {
    var publicMethods, settings;

    var elmResultContainer = null, elmResultContainerList,
        elmSelectAll,
        elmCloseIcon;

    var elmInput = $(input);
    var checkedItems = {};
    var searchKeywordsLog = {};
    var isLoadingMore = false;

    var state = {
      id: 'full',
      keyword: '',
      set_state_full: function() {
        this.id = 'full';
        this.keyword = '';
      },
      set_state_filter: function(searchword) {
        this.id = 'filter';
        this.keyword = searchword;
      },
      saveState: function() {
        return {
          id: state.id,
          keyword: state.keyword,
          checkedItems: checkedItems,
          allCheckboxChecked: elmSelectAll.is(':checked'),
          searchFunc: settings.searchFunc,
          searchEnabled: settings.searchEnabled,
          searchKeywordsLog: searchKeywordsLog
        };
      },
      loadState: function(data, stateObject, idKey) {
        checkedItems = stateObject.checkedItems;
        settings.idKey = idKey;
        set_data(data);
        flushSelectAllCache = true;

        searchKeywordsLog = stateObject.searchKeywordsLog;
        if (stateObject.searchFunc) {
          settings.searchFunc = stateObject.searchFunc;
        }
        settings.searchEnabled = stateObject.searchEnabled;
        elmInput.unbind('input');
        bindSearchEvent();

        if (stateObject.id === 'filter') {
          elmInput.val(stateObject.keyword);
          onInputKey.apply(elmInput, [null, true]);
        } else {
          state.set_state_full();
        }
        if (stateObject.allCheckboxChecked) {
          elmSelectAll.prop('checked', true);
        } else {
          elmSelectAll.prop('checked', false);
        }
      }
    };

    /*** constructor ***/

    function init(options) {
      settings = options;
      elmResultContainer = settings.elmResultContainer || $(settings.classes.resultContainer);
      elmSelectAll = $(settings.classes.selectAll);
      elmCloseIcon = $(this).siblings('.close-icon');


      // Pre load checked items if passed as options
      if(options.checkedItems) {
        checkedItems = options.checkedItems;
      }

      settings.index = lunr(function() {
        this.field('name');
        if (settings.searchInEmail) {
          this.field('mail');
        }
        this.ref(settings.idKey);

        this.pipeline.add(function (token, tokenIndex, tokens) {
          return textUtils.removeDiacritics(token);
        });
      });

      if (settings.preselectAll) {
        checkedItems = get_all_checked_list();
        elmSelectAll.prop('checked', true);
      }

      if (settings.data.length > 0) {
        _.each(settings.data, function(item) {
          settings.index.add(item);
        });

        render(settings.data);
      } else if (_.isFunction(settings.templates.emptyInitial)) {
        elmResultContainer.html(settings.templates.emptyInitial());
      }

      // Event bindings
      if(settings.searchInstantSearchCallback) {
        elmInput.bind('keyup', onInputKey);
      } else {
        bindSearchEvent();
      }

      elmResultContainer.delegate("input[type='checkbox']", 'change', onCheckboxChanged);
      elmResultContainer.delegate("li", 'click', onListItemClicked);

      elmCloseIcon.bind('click', onCloseItemClicked);
      elmSelectAll.bind('click', onSelectAllClicked);
    }

    function bindSearchEvent() {
      var inputFunc, helperFunc;

      /* if searching wait for typing to complete before firing the event callback */
      if (settings.searchEnabled && _.isFunction(settings.searchFunc)) {
        helperFunc = _.debounce(onInputKey, 600);
        inputFunc = function() {
          elmInput.trigger('searchStarted');
          helperFunc.apply(this, [null].concat(Array.prototype.slice.call(arguments, 1)) );
        };
      } else {
        inputFunc = onInputKey;
      }

      // event binding
      elmInput.bind('input', inputFunc);
    }


    function onSelectAllClicked(e) {
      if ($(this).is(':checked')) {
        uncheck_all(true);
        check_all();
      } else {
        uncheck_all();
      }
    }

    function onCloseItemClicked(e) {
      elmInput.val('');
      onInputKey.apply(elmInput);
      $(this).hide();
    }

    function clearSearchField() {
      elmInput.val('');
    }

    function onListItemClicked(e) {
      var elmTarget = $(this);

      var isCheckbox = $(e.target).is('input[type=checkbox]');

      if($(e.target).is('input') && !isCheckbox) {
        return true;
      }

      var isNonCheckable = elmTarget.hasClass(settings.classes.nonCheckable);

      if (!isCheckbox && isNonCheckable) {
        e.preventDefault();
      }

      if(isNonCheckable) {
        settings.callbacks.onNonCheckableClick( elmTarget.data('key'), elmTarget, e);
      }

      if (!isCheckbox && !isNonCheckable) {
        // Emulates label click behaviour manually
        var elmTargetInput = elmTarget.find('.img-ext input');
        elmTargetInput.prop('checked', !elmTargetInput.prop('checked') );
        elmTargetInput.trigger('change');
      }
    }

    function onCheckboxChanged(e) {
      e.stopPropagation();

      var elmTarget = $(this);
      var key = elmTarget.data('key');

      if (settings.inviteLimit && elmTarget.is(':checked') && _.size(checkedItems) === settings.inviteLimit) {
        elmTarget.prop('checked', false);
        elmInput.trigger('podio:checklist:checkLimitReached', key);
        return false;
      }

      elmTarget.parents('li').toggleClass('checked');

      elmSelectAll.prop('checked', false);

      if (elmTarget.is(':checked')) {
        checkedItems[key] = true;
        settings.callbacks.onCheck(key, findItemById(key));

        if (settings.inviteLimit && _.size(checkedItems) === settings.inviteLimit) {
          elmInput.trigger('podio:checklist:checkLimitReached', key);
        }

      } else {
        delete checkedItems[key];
        settings.callbacks.onUncheck(key, findItemById(key));
      }
    }

    function findItemById(key) {
      var result = _(settings.data).find(function(item) {
        // do a loose comparison here, since we want to match string and int keys
        return item[settings.idKey] == key;
      });

      return result;
    }

    function showLoadMoreSpinner() {
      elmResultContainerList.append('<li class="loading-overlay-small load-more-spinner"></div>');
    }

    function hideLoadMoreSpinner() {
      elmResultContainerList.find('.load-more-spinner').remove();
    }

    function onListScroll(e) {
      var elmLastElement = elmResultContainerList.find('*:last');

      var bounderyCurrentBottom = elmResultContainerList.height() + elmResultContainerList.scrollTop();
      var bounderyLastItemTop = elmResultContainerList.prop('scrollHeight') - elmLastElement.height() - settings.loadMoreScrollThreshold;

      if (bounderyCurrentBottom > bounderyLastItemTop) {
        // Fetch
        fetchMoreItems();
      }

    }

    // TODO this is getting too complicated, refactor!
    function onInputKey(e, bypassSearch) {
      var keyword = $(this).val();
      var filteredData;
      var searchCompleted;

      if (keyword.length > 0) {

        if (settings.searchEnabled && _.isFunction(settings.searchFunc) && !bypassSearch) {
          elmInput.trigger('searchStarted');
          searchCompleted = searchOnServerAndAppend(keyword, settings.cacheKeyPrefix ? settings.cacheKeyPrefix() : '');
        } else {
          searchCompleted = true;
        }

        $.when(searchCompleted).then(function() {
          filteredData = filter(settings.data, keyword);
          if (elmCloseIcon.length > 0 && elmCloseIcon.is(':hidden')) {
            elmCloseIcon.show();
          }
          render(filteredData);
        });
      } else {
        filteredData = settings.data;
        if (elmCloseIcon.length > 0 && elmCloseIcon.is(':visible')) {
          elmCloseIcon.hide();
        }
        render(filteredData);
        elmInput.trigger('podio:checklist:inputCleared');
      }
    }

    /*** private functions ***/

    // a memoized function
    var get_all_checked_list = (function() {
      var cache = {};
      return function() {
        if (_.isEmpty(cache)) {
          try {
            _.each(settings.data, function(item, index) {
              if (settings.inviteLimit && index === settings.inviteLimit) {
                elmInput.trigger('podio:checklist:checkLimitReached', item[settings.idKey]);
                throw 'break';
              }
              cache[item[settings.idKey]] = true;
            });
          } catch (e) {}
          return cache;
        } else {
          return cache;
        }
      };
    })();

    function check_all() {
      var lis = (settings.inviteLimit ? 'ul li:lt('+settings.inviteLimit+')' : 'ul li');
      var checkboxes = lis+' input';
      elmResultContainer.find(checkboxes).prop('checked', true);
      elmResultContainer.find(lis).addClass('checked');
      checkedItems = get_all_checked_list();

      if(_.isFunction(settings.callbacks.onSelectAll)) {
        settings.callbacks.onSelectAll();
      }
    }

    function uncheck_all(nocallback) {
      elmResultContainer.find("input[type='checkbox']").prop('checked', false);
      elmResultContainer.find("li").removeClass('checked');
      checkedItems = {};

      if(_.isFunction(settings.callbacks.onUnselectAll) && !nocallback) {
        settings.callbacks.onUnselectAll();
      }
    }

    function render_items(items) {
      var renderedData = '';

      if(items.length) {
        // breaking out of the loop after 500 contacts if IE
        try {
          _.each(items, function(item, index) {
            var classNames = item.className ? item.className.split(' ') : [];
            var isCheckable = _.isUndefined(item.isCheckable) ? true : item.isCheckable;

            if (index > 499 && browser.msie) {
              throw 'break';
            }

            if (settings.renderLimit && index >= settings.renderLimit) {
              throw 'break';
            }

            if((index+1) % settings.columns === 0 && index > 0) {
              classNames.push('last');
            }
            if((index) % settings.columns === 0 ) {
              classNames.push('first');
            }

            if(!isCheckable) {
              classNames.push(settings.classes.nonCheckable);
            }

            renderedData += settings.templates.item({
              className : classNames.join(' '),
              data: item,
              checked: checkedItems[item[settings.idKey]],
              key: item[settings.idKey],
              type: settings.idKey,
              customCheckbox : settings.customCheckbox,
              isCheckable: isCheckable,
              tabindex: index === 0 ? settings.firstElementTabIndex : null
            });
          });
        } catch (e) {}
      } else if(_.isFunction(settings.templates.empty)) {
        renderedData += settings.templates.empty();
      }

      return renderedData;
    }

    function render(data) {
      var renderedData = render_items(data);
      var renderedList = settings.templates.list({ content : renderedData });
      elmResultContainer.html(renderedList);

      elmResultContainerList = elmResultContainer.find('ul');

      if(settings.enableScrollLoadMore) {
        elmResultContainerList.bind("scroll.podiochecklist", _.throttle(onListScroll, 100));
      }

      elmInput.trigger('contactLoadFinished', data.length);
    }

    function fetchMoreItems() {

      if(!settings.loadMoreFunc) {
        return;
      }

      if(isLoadingMore) {
        return;
      }

      // UI
      showLoadMoreSpinner();

      // State
      isLoadingMore = true;

      settings.loadMoreFunc(function(items) {
        _.each(items, function(item) {
          appendItem(item);
        });

        isLoadingMore = false;

        // UI
        hideLoadMoreSpinner();

        if(items.length) {
          renderMoreItems(items);
        } else {
          // Disable scroll load more
          elmResultContainerList.unbind('scroll.podiochecklist');
        }

      });
    }

    function renderMoreItems(data) {
      var renderedItems = render_items(data);
      elmResultContainerList.append(renderedItems);

      elmInput.trigger('moreItemsRendered');
    }

    function filter(data, keyword) {
      var results = settings.index.search(keyword);

      return _.map(results, function(result) {
        return findItemById(result.ref);
      });
    }

    function appendItem(item) {
      var existing = findItemById(item[settings.idKey]);
      if (_.isUndefined(existing)) {
        settings.data.push(item);
        settings.index.add(item);
      }
    }

    function searchOnServerAndAppend(keyword, cacheKeyPrefix) {
      var dfd = $.Deferred();

      var cacheKey = cacheKeyPrefix+keyword;

      if (searchKeywordsLog[cacheKey]) {
        dfd.resolve();
        return dfd;
      }

      settings.searchFunc(keyword, function(items) {
        _.each(items, function(item) {
          appendItem(item);
        });

        searchKeywordsLog[cacheKey] = true;
        dfd.resolve();
      });

      return dfd;
    }

    /*** public functions ***/
    function dispose() {

      // Event handlers
      if(elmResultContainer) {
        elmResultContainer.undelegate("input[type='checkbox']", 'change');
        elmResultContainer.undelegate("li", 'click');

        elmResultContainer.empty();
      }

      if(elmInput) {
        elmInput.unbind('input');
      }

      if(elmCloseIcon) {
        elmCloseIcon.unbind('click');
      }

      if(elmSelectAll) {
        elmSelectAll.unbind('click');
      }

      // State
      $.data(input, 'podioChecklist', null);

    }

    function resetData(data, idKey, selectAll, searchFunc, searchEnabled) {
      settings.data = data;
      settings.idKey = idKey;
      settings.searchFunc = searchFunc;
      settings.searchEnabled = searchEnabled;
      elmInput.unbind('input');
      bindSearchEvent();
      flushSelectAllCache = true;
      searchKeywordsLog = {};
      state.set_state_full();
      if (selectAll) {
        checkedItems = get_all_checked_list();
        elmSelectAll.prop('checked', true);
      } else {
        checkedItems = {};
        elmSelectAll.prop('checked', false);
      }
      render(data);
    }

    function updateCheckedState(checkedState, data) {
      checkedItems = checkedState;

      render(data);
    }

    function get_data() {
      return settings.data;
    }

    function getCheckedIds() {
      return _.keys(checkedItems);
    }

    // expose public methods
    publicMethods = {
      init: init,
      clearSearchField: clearSearchField,
      updateCheckedState : updateCheckedState,
      getCheckedIds: getCheckedIds,
      getData: get_data,
      dispose: dispose
    };

    return publicMethods;
  };

  $.fn.podioChecklist = function (methodOrSettings) {

    var outerArguments = arguments;
    var returnValue;

    this.each(function () {
      var instance = $.data(this, 'podioChecklist') || $.data(this, 'podioChecklist', new $.podioChecklist(this));

      if (_.isFunction(instance[methodOrSettings])) {
        returnValue = instance[methodOrSettings].apply(this,Array.prototype.slice.call(outerArguments, 1));

      } else if (typeof methodOrSettings === 'object' || ! methodOrSettings) {
        var passedSettings = methodOrSettings || {};
        var settings = $.extend(true, {}, defaultSettings, passedSettings);

        returnValue = instance.init.call(this, settings);

      } else {
        $.error('Method ' + methodOrSettings + ' does not exist');
      }

    });

    return returnValue || this;

  };

});

